import React from "react";
import ReactDOM, { createPortal } from "react-dom";
import jQuery from "jquery";
import "jqueryui";
import App from "./components/App";
import AsyncPage from "./components/utils/async-page";
import Preloader from "./components/utils/preloader";
import NewsAudio from "./components/utils/news-player";
import getCookie from "./components/utils/cookie-handler";

declare global {
  interface Window {
    $: typeof jQuery;
    AUDIO_URL: string;
    CHANNEL_ID: number;
    async: AsyncPage;
  }
}

async function GetStreamsByLocation(lat, long) {
  const locationApiUrl = "https://api.suspilne.radio/get_streams.php";
  const url = `${locationApiUrl}?lat=${lat}&lng=${long}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch streams:", error);
    return null;
  }
}

function dateFormat(day) {
  let result =
    day.getFullYear() +
    "-" +
    ("0" + (day.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + day.getDate()).slice(-2);
  return result;
}

function setDefaultRegionToCookies() {
  let switchElement = document.querySelector('#region-switch') as HTMLElement;
  let defaultRegionId = (switchElement) ? switchElement.dataset.defaultRegionId : null;
  if (defaultRegionId)
  document.cookie = "regID=" + defaultRegionId + "; max-age=2678400; path=/";
}

window.$ = jQuery;
const preloader = Preloader.getInstance();
const runJs = () => {
  const currentUrl = new URL(window.location.href);
  if ($("#calendar")) {
    let calendar = $("#calendar");
    let dates = calendar.data("archive-dates");
    let currentDate = calendar.data("archive-current-date");
    calendar.datepicker({
      monthNames: [
        "Січень",
        "Лютий",
        "Березень",
        "Квітень",
        "Травень",
        "Червень",
        "Липень",
        "Серпень",
        " Вересень",
        "Жовтень",
        "Листопад",
        "Грудень",
      ],
      dayNamesMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      firstDay: 1,
      prevText: "<",
      nextText: ">",
      defaultDate: new Date(currentDate),
      beforeShowDay: function (day) {
        {
          if (calendar) {
            let dateString = dateFormat(day);
            let selectable = false;
            let hasArchive = "";
            // if (dates.includes(dateString)) {
            //   (selectable = true), (hasArchive = "has-archive");
            // }
            if (dateString <= dateFormat(new Date())) {
              (selectable = true), (hasArchive = "has-archive");
            }
            if (currentDate == dateString) {
              hasArchive += " archive-current-date";
            }
            return [selectable, hasArchive];
          }
        }
      },
      onSelect: function (date) {
        let progID = $("#calendar").data("prog-id");
        let newDate = new Date(date);
        let dateString = dateFormat(newDate);
        let date_format = /[&]date=........../;
        let prog_format = /[&]progID=\d+/;
        let page_format = /[&]page=\d+/;
        let slide_format = /[&]sliderIndex=\d+/;
        let hash_format = /#\S*/;
        let link = window.location.href;
        link = link.replace(hash_format, "");
        if (link.includes("date=")) {
          link = link.replace(date_format, "&date=" + dateString);
        } else link += "&date=" + dateString;
        if (link.includes("progID=")) {
          link = link.replace(prog_format, "");
        }
        if (link.includes("page=")) {
          link = link.replace(page_format, "");
        }
        if (link.includes("sliderIndex=")) {
          link = link.replace(slide_format, "&sliderIndex=0");
        } else {
          link += "&sliderIndex=0";
        }
        window.history.pushState("", "", link);
        window.async.loadPage(link, false);
      },
    });
  }
  $(".top-nav-menu").removeClass("open");

  const regionsList = document.getElementById("regions-list");
  const regionSwitch = document.getElementById("region-switch");

  if (regionsList && regionSwitch) {
    regionSwitch.addEventListener("click", function () {
      regionSwitch.classList.toggle("active");
      regionsList.classList.toggle("active");
    });

    document.addEventListener("click", function (event) {
      if (
        !regionsList.contains(event.target as HTMLElement) &&
        !regionSwitch.contains(event.target as HTMLElement) &&
        regionsList.classList.contains("active")
      ) {
        regionsList.classList.remove("active");
      }
    });
  }

  if ($(".stream-switch-holder").length) {
    // Get the current URL
    let cookie_regid = getCookie("regID");
    if (cookie_regid) {
      if (!currentUrl.searchParams.has("regID")) {
        currentUrl.searchParams.append("regID", cookie_regid);
        // Reload the page with the new URL
        window.history.pushState("", "", currentUrl.toString());
        window.async.loadPage(currentUrl.toString(), false);
      }
    }
    // Check if Geolocation is supported
    else if (navigator.geolocation) {
      // Request the current position
      navigator.geolocation.getCurrentPosition((position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        GetStreamsByLocation(latitude, longitude)
          .then((data) => {
            // Check if 'regID' is present in the URL
            if (!currentUrl.searchParams.has("regID")) {
              document.cookie =
                "regID=" + data.id + "; max-age=2678400; path=/";
              // If not present, add 'regID' with the value of data.id
              currentUrl.searchParams.append("regID", data.id);
              // Reload the page with the new URL
              window.history.pushState("", "", currentUrl.toString());
              window.async.loadPage(currentUrl.toString(), false);
            }
          })
          .catch(setDefaultRegionToCookies);
      }, setDefaultRegionToCookies);
    }
  }

  if ($("ul#regions-list").length) {
    let list = $("ul#regions-list li a").toArray();
    list.forEach((link) => {
      link.addEventListener("click", () => {
        const audioElement = document.getElementById(
          "audio-element-player"
        ) as HTMLMediaElement;

        if (!audioElement.paused && audioElement.currentTime > 0) {
          $("#audio-element-player").attr("data-region-updated", "true");
        }
        document.cookie =
          "regID=" + link.dataset.regId + "; max-age=2678400; path=/";
      });
    });
  }

  if ($("#audio-element-player").attr("data-region-updated") === "true") {
    $("#audio-element-player").removeAttr("data-region-updated");
    let qualityNumber = 0;
    // Now, retrieve the number from the audio element
    var audioElement = document.getElementById("audio-element-player");

    if (audioElement) {
      // Get the data-data-current-quality attribute
      var currentQuality = audioElement.getAttribute(
        "data-data-current-quality"
      );

      // If currentQuality is not null, parse it as an integer
      if (currentQuality !== null) {
        qualityNumber = parseInt(currentQuality, 10);
      }
    }

    // Select the parent element
    var holder = document.querySelector(".stream-switch-holder");

    // Check if the holder exists
    if (holder) {
      // Get the direct children (element nodes only)
      var children = Array.from(holder.children) as HTMLElement[]; // Convert HTMLCollection to array

      // Check for the child
      if (children[qualityNumber]) {
        // Click the child if it exists
        children[qualityNumber].click();
      } else if (children[0]) {
        // Otherwise, click the first child if it exists
        children[0].click();
      }
    }
  }
};
const async = new AsyncPage("page-root");
window.async = async;
runJs();
NewsAudio.init();
async.addEventListener("pageloaded", () => runJs());
async.addEventListener("pageloaded", () => preloader.hide());
async.addEventListener("pageloaded", () => NewsAudio.init());
async.addEventListener("pageloading", () => preloader.show());

ReactDOM.render(<App />, document.querySelector("#react-root"));
